var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeroLineDetail1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 867,
    height: 1299,
    viewBox: "0 0 867 1299"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#E9E61F",
    strokeWidth: 2,
    d: "M432 864.790713C193.415372 864.790713 0 1058.20608 0 1296.79071L432 1296.79071 432 864.790713zM432 864.790713C432 626.206085 238.589738 432.790713 0 432.790713L0 864.790713 432 864.790713zM432 864.790713C670.584628 864.790713 864 671.380451 864 432.790713L432 432.790713 432 864.790713zM432 432.790713C432 194.206085 238.589738.790713324 0 .790713324L0 432.790713 432 432.790713z",
    transform: "translate(1.404 .476)"
  })));
}

export default __webpack_public_path__ + "static/hero-line-detail-1-3f0b54771e1e9c58d6ade799d152db2d.svg";
export { SvgHeroLineDetail1 as ReactComponent };